module.exports = __webpack_public_path__ + "assets/shopify.70791faa.svg";